import React, { useState } from "react";
import { useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import HorarioPanel from "./Horario/HorarioPanel";
import CardHorario from "./Horario/CardHorario";
import RowCourse from "./Horario/RowCourse";
import ModalConfirmacionFranjaHorario from "./Horario/ModalConfirmacionFranjaHorario";
import { apiAsignatura, apiAsignaturaFranja, apiGrupos, apiGruposFranja, apiAsignaturaMasivaFranja } from "../config/constantes";
import {
  update_paso,
  listado_asignaturas_estudiante,
  sesionesHabilitadas,
  listado_datosEstudiante_logeadoSinLoading,
} from "../services/procesoMatricula/procesoMatricula";


import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import useAuth from "../hooks/useAuth";
import { MultiSelect } from "react-multi-select-component";
import { formatterDate } from "../utils/FormatterDate";
import Swal from 'sweetalert2'

const Horario = () => {
  let { listadoAsignaturas, gruposHabilitados, setGruposHabilitados, obtenerDatosEstudiante, setObtenerDatosEstudiante,
    setObtenerDatosEstudianteSinFiltro, setListadoAsignaturas,
    mostrarAsignaturas, setMostrarAsignaturas, franjaActual, setFranjaActual, multifranjas } =
    useMatricula();

  let [listadoAsignaturasFiltrar, setListadoAsignaturasFiltrar] = useState([]);
  let {
    setPasoProcesoM,
    setPasoSegundaVistaProcesoM,
    setListadoAsignaturasEstudiante,
    listAsignaturasAgregadas,
    setMsgModalHorario,
    setLoading,
    setListEventos,
  } = useProcesoMatricula();

  const { cinstitucion, cprograma, cperiodo, cpersona, franja } =
    obtenerDatosEstudiante || {};

  let { listadoFranjas, franjaSeleccionadaHorario, setFranjaSeleccionadaHorario } = useMatricula()


  const [busquedaAsignatura, setBusquedaAsignatura] = useState("");
  const [mostrarBotonVolver, setMostrarBotonVolver] = useState(false);
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));


  //contador de la tabla de asignatura

  const [countC, setCountC] = useState(0);
  const [countE, setCountE] = useState(0);
  const [countO, setCountO] = useState(0);
  const [creditosCount, setCreditosCount] = useState(0);
  const [horasCount, setHorasCount] = useState(0);

  //Cambio de idioma
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  //multiselect
  const [selected, setSelected] = useState([]);
  let [limitAsignatura, setLimitAsignatura] = useState({});
  let [disableBotonContinuar, setDisableBotonContinuar] = useState(true);
  let [disableSelectFranjas, setDisableBSelectFranjas] = useState(true);

  let [
    gruposHabilitadosFiltrarSinDuplicado,
    setGruposHabilitadosFiltrarSinDuplicado,
  ] = useState([]);
  let [gruposHabilitadosFiltrar, setGruposHabilitadosFiltrar] = useState([]);
  let { mincredito } = obtenerDatosEstudiante || {};

  //Para el listado de las tarjetas
  const [listGruposEquivalenteArmadosPadre, setGruposEquivalenteArmadosPadre] = useState([]);
  const [listGruposEquivalenteArmados, setGruposEquivalenteArmados] = useState([]);

  const prometeValidarApi = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config).then((data) => {
        if (data.status == 200) {
          resolver(data);
        } else {
          rechazar(new Error(data));
        }
      });
    });
  };


  const handleSeleccionarFranja = async (event) => {
    if (event.target.value == '') {
      setFranjaSeleccionadaHorario(event.target.value)
      setMostrarAsignaturas(false)
    } else {
      handleSeleccionConfirmarFranja(event.target.value)
    }
  }

  useEffect(() => {
    if (franjaSeleccionadaHorario == '') {
      setMostrarAsignaturas(false)
    }
  }, [franjaSeleccionadaHorario])

  const handleSeleccionConfirmarFranja = (franja) => {
    setFranjaSeleccionadaHorario(franja)
    let confirmacionModal = document.getElementById('modalConfirmarFranja')
    confirmacionModal.click()
  }

  const getAsignaturas = async () => {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
      }),
    };

    const configFranjas = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_franja: franjaActual,
      }),
    };
    try {
      setLoading(true);
      setListadoAsignaturas([])
      let listaCursos = [];
      if (multifranjas) {
        listaCursos = await prometeValidarApi(`${apiAsignaturaFranja}`, configFranjas);
      } else {
        listaCursos = await prometeValidarApi(`${apiAsignatura}`, config);
      }

      const listaCursosJSON = await listaCursos.json();
      const { Data } = listaCursosJSON;

      setListadoAsignaturas(Data);

      return Data

    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
      return true;
    }
  }

  let getGruposHabilitados = async () => {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
      }),
    };

    const configFranjas = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_franja: franjaSeleccionadaHorario
      }),
    };
    try {
      setLoading(true);
      let listaCursos = [];

      if (multifranjas) {
        listaCursos = await prometeValidarApi(`${apiGruposFranja}`, configFranjas);
      } else {
        listaCursos = await prometeValidarApi(`${apiGrupos}`, config);
      }

      const listaCursosJson = await listaCursos.json();
      const { Data } = listaCursosJson;

      let listOrdenadaEquivalente = Data.sort(function (a, b) {
        if (a.dcurso < b.dcurso) {
          return -1;
        }
        if (a.dcurso > b.dcurso) {
          return 1;
        }

        if (a.dequivalente < b.dequivalente) {
          return -1;
        }
        if (a.dequivalente > b.dequivalente) {
          return 1;
        }
        return 0;
      });

      setGruposHabilitados(listOrdenadaEquivalente);
      return listOrdenadaEquivalente;
    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
      return true;
    }
  };


  const asignacionMasiva = async () => {

    setDisableBSelectFranjas(true)
    setDisableBotonContinuar(true)

    let respuestaAsignacionMasiva = await asignarAsignaturas()

    setDisableBSelectFranjas(false)
    setDisableBotonContinuar(false)

    const { Data } = respuestaAsignacionMasiva;

    if (Data?.respuesta == 1) {

      setLoading(true)

      await listado_datosEstudiante_logeadoSinLoading(
        setObtenerDatosEstudianteSinFiltro,
        setObtenerDatosEstudiante,
        obtenerDatosEstudiante
      );
      setFranjaActual(franjaSeleccionadaHorario)
      setLoading(false)

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Se registraron las asignaturas correctamente.",
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#B01333',

        willOpen: () => {
          document.querySelector('.swal2-popup').style.fontFamily = '"Barlow", sans-serif';
          document.querySelector('.swal2-popup').style.fontSize = '15px';
        }
      });
    } else {
      let htmlList = `<ul style="text-align: justify; padding-left: 40px; padding-right:40px;" >`;
      Data?.Errors.forEach(item => {
        htmlList += `<li style="display: flex; gap:4px;"><i class="pi pi-times-circle" style="margin-top: 2px; color: #B01333";></i> <div> ${item.descripcion} </div></li> <br/>`;
      });
      htmlList += `</ul>`;

      Swal.fire({
        icon: "info",
        title: "¡Alerta!",

        html: `<div>
        No es posible realizar la asignación ya que se encontraron las siguientes incidencias:</br>
        <br/>
        ${Data?.Errors.length > 4 ?
            `<div style="overflow: auto; height: 250px; background-color:rgb(255, 233, 235);  border-radius: 10px; padding-top: 20px; margin: 0px 5%;" >
              ${htmlList}
            </div>`
            :
            ` <div style="background-color:rgb(255, 233, 235); border-radius: 10px; padding-top: 20px; margin: 0px 5%;">
              ${htmlList}
            </div>`
          }   
                  <br/>    
        <span> Por favor, comuníquese con la OAMRA.  </span>
        </div>`,
        width: '35%',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#B01333',
        willOpen: () => {
          document.querySelector('.swal2-popup').style.fontFamily = '"Barlow", sans-serif'; // Cambiar la fuente
          document.querySelector('.swal2-popup').style.fontSize = '15px';
        }
      });

      setFranjaSeleccionadaHorario(franjaActual)
    }
  }


  const asignarAsignaturas = async () => {
    const configFranjas = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_franja: franjaSeleccionadaHorario,
      }),
    };
    try {
      setLoading(true);
      setListadoAsignaturas([])
      let respuestaAsignacionMasiva = [];
      if (multifranjas) {
        respuestaAsignacionMasiva = await prometeValidarApi(`${apiAsignaturaMasivaFranja}`, configFranjas);
      }
      const asignacionMasivaJSON = await respuestaAsignacionMasiva.json();

      return asignacionMasivaJSON;
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Algo salió mal. Intente nuevamente.",
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#B01333',

        willOpen: () => {
          document.querySelector('.swal2-popup').style.fontFamily = '"Barlow", sans-serif'; // Cambiar la fuente
          document.querySelector('.swal2-popup').style.fontSize = '14px'; // Cambiar el tamaño del texto del modal
        }
      });
      throw error;
    } finally {
      setLoading(false);
    }
  }


  let filtrarDia = (dia) => {
    switch (dia) {
      case "Lu":
        return 1;
        break;
      case "Ma":
        return 2;
        break;
      case "Mi":
        return 3;
        break;
      case "Ju":
        return 4;
        break;
      case "Vi":
        return 5;
        break;
      case "Sá":
        return 6;
        break;
      default:
        break;
    }
  };

  const formatHora = (fechaEntrada) => {
    const fecha = new Date(fechaEntrada);
    const hora = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');

    const horaFormateada = `${hora}:${minutos}`;

    return horaFormateada;
  }


  function sumarDiasFinFullCalendar(fecha, dias) {
    let dataFinal = new Date(fecha).setDate(new Date(fecha).getDate() + dias);
    return dataFinal;
  }

  const pushEventos = (data) => {


    const handleAddEventRangoFecha = (listado, listevents) => {
      let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;
      let descritions = `<ul>
      <li>Equivalente: <strong>${listado.dequivalente}</strong> </li>  
      <li>Grupo: <strong> ${listado.sgrupo}</strong></li>
      <li>Modalidad:<strong> ${listado.dmodalidad}
      </strong></li>
      <li>Horario: <strong>${listado.dhorario
        }</strong></li><li>Inicio: <strong>${formatterDate(
          listado.finicio
        )}</strong> </li><li >Fin: <strong>${formatterDate(
          listado.ffin
        )}</strong> </li> <li >Docente: <strong>${listado.ddocente
        }</strong> </li><li >Créditos: <strong>${listado.ncredito}</strong> </li>  
      </ul>   
      `;
      let evento1 = {
        id: codigoUnico,
        title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
        description: descritions,
        startRecur: listado.hinicio,
        endRecur: new Date(sumarDiasFinFullCalendar(listado.hfinal, 1)),
        startTime: formatHora(listado.hinicio),
        endTime: formatHora(listado.hfinal),
        daysOfWeek: [listado.ndia],
      };

      listevents.push(evento1);
    };
    const validarDelMismoDia = (fechaInicio, fechaFin) => {
      const fecha1 = new Date(fechaInicio);
      const fecha2 = new Date(fechaFin);

      const esMismoDia =
        fecha1.getDate() === fecha2.getDate() &&
        fecha1.getMonth() === fecha2.getMonth() &&
        fecha1.getFullYear() === fecha2.getFullYear();
      return esMismoDia;
    };


    let dataEventos = [];


    data.forEach((listado) => {
      if (validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras > 0) {
        let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;

        let descritions = `<ul><li>Equivalente: <strong> ${listado.dequivalente
          }
          </strong></li>
          <li>Grupo:<strong> ${listado.sgrupo}
          </strong></li>
          <li>Modalidad:<strong> ${listado.dmodalidad}
          </strong></li>
          <li>Horario: <strong>${listado.dhorario
          }</strong></li><li>Inicio: <strong>${formatterDate(
            listado.finicio
          )}</strong> </li><li >Fin: <strong>${formatterDate(
            listado.ffin
          )}</strong> </li> <li >Docente: <strong>${listado.ddocente
          }</strong> </li><li >Créditos: <strong>${listado.ncredito
          }</strong> </li></ul>`;

        let evento;

        evento = {
          id: codigoUnico,
          title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
          description: descritions,
          start: listado.hinicio,
          end: listado.hfinal,
        };

        dataEventos.push(evento);

      }
    });
    data.forEach((listado) => {
      if (!validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras > 0) {

        handleAddEventRangoFecha(listado, dataEventos);
      }

      if (!validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras === 0) {
        let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;

        let descritions = `<ul><li>Equivalente: <strong> ${listado.dequivalente
          }
          </strong></li>
          <li>Grupo:<strong> ${listado.sgrupo}
          </strong></li>
          <li>Modalidad:<strong> ${listado.dmodalidad}
          </strong></li>
          <li>Horario: <strong>${listado.dhorario
          }</strong></li><li>Inicio: <strong>${formatterDate(
            listado.finicio
          )}</strong> </li><li >Fin: <strong>${formatterDate(
            listado.ffin
          )}</strong> </li> <li >Docente: <strong>${listado.ddocente
          }</strong> </li><li >Créditos: <strong>${listado.ncredito
          }</strong> </li></ul>`;


        let evento;
        evento = {
          id: codigoUnico,
          title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
          description: descritions,
          start: listado.hinicio,
          end: listado.hfinal,
          allDay: true,
        };
        dataEventos.push(evento);

      }
    });

    setListEventos(dataEventos);
  };



  const validarBtnHorario = () => {
    let modal = document.querySelector("#bntCruce");
    //Primero validar
    if (creditosCount >= mincredito) {
      if (creditosCount <= limitAsignatura.nlimitecreditos) {
        //Despues setear los campos de estado
        setPasoSegundaVistaProcesoM(true);
        // seteoDeObjectMatricula("nextHorario");
      } else {
        if (modal) {
          modal.click();
        }

        setMsgModalHorario({
          title: `${lbl_horario_limite_creditos}`,
          text: `${lbl_horario_msj_excediendo_creditos} (${lbl_horario_max_credito} ${limitAsignatura.nlimitecreditos}).`,
        });
      }
    } else {
      if (modal) {
        modal.click();
      }
      setMsgModalHorario({
        title: `${lbl_horario_limite_creditos}`,
        text: `${lbl_horario_msj_llegas_creditos} (${lbl_horario_min_creditos} ${mincredito})`,
      });
    }
  };

  const atrasBtnHorario = async () => {
    try {

      setLoading(true);
      //Despues setear los campos de estado
      let updatePasos = await update_paso(obtenerDatosEstudiante, 2, 1);
      let convertirPasoCompletadoMayoCero = Number(
        updatePasos.Data.paso_siguiente
      );
      let convertirPasoCompletado =
        convertirPasoCompletadoMayoCero > 0
          ? convertirPasoCompletadoMayoCero - 1
          : convertirPasoCompletadoMayoCero;
      setPasoProcesoM(convertirPasoCompletado);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    listado_asignaturas_estudiante(
      obtenerDatosEstudiante,
      setListadoAsignaturasEstudiante,
      setLoading
    );

  }, [obtenerDatosEstudiante]);
  useEffect(() => {
    let datas;
    let hash = {};
    datas = gruposHabilitados.filter((o) =>

      hash[o.scurso] ? false : (hash[o.scurso] = true)
    );



    setGruposHabilitadosFiltrar(datas);
    setGruposHabilitadosFiltrarSinDuplicado(datas);
  }, [gruposHabilitados]);

  useEffect(() => {
    setListadoAsignaturasFiltrar(listadoAsignaturas);

    let traerUnaAsignaturaParaLimite = () => {
      listadoAsignaturas.map((data, index) => {
        if (index == 0) {
          setLimitAsignatura(data);
        }
      });
    };
    traerUnaAsignaturaParaLimite();
  }, [listadoAsignaturas]);

  let handleBuscar = (busquedaChange = "", tipo = 1) => {
    let valorFiltrar = tipo == 1 ? busquedaAsignatura : busquedaChange;

    let dataFilter = listGruposEquivalenteArmadosPadre.filter((info) => {
      return (
        info.nombreAsignatura
          .toLowerCase()
          .indexOf(String(valorFiltrar).toLowerCase()) !== -1
      );
    });
    setGruposEquivalenteArmados(dataFilter);
  };
  let handleMultiSelect = (e) => {
    setSelected(e);

    let data = [];
    let respues = e.map((seleccionado) => {
      listGruposEquivalenteArmadosPadre.map((grupos) => {
        if (grupos.nombreAsignatura == seleccionado.value) {
          data = grupos;
        }
      });

      return data;
    });

    let infoAFiltrar =
      respues.length > 0 ? respues : listGruposEquivalenteArmadosPadre;

    setGruposEquivalenteArmados(infoAFiltrar);
  };



  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_seleccion_horario: obtenerLabelEtiqueta(
          "lbl_global_seleccion_horario",
          listadoEtiquetas
        ),
        asignaturas_habilitadas: obtenerLabelEtiqueta(
          "lbl_horario_asignaturas_habilitadas",
          listadoEtiquetas
        ),
        horario_preliminar: obtenerLabelEtiqueta(
          "lbl_horario_preliminar",
          listadoEtiquetas
        ),
        limite_asignaturas: obtenerLabelEtiqueta(
          "lbl_home_limite_asignaturas",
          listadoEtiquetas
        ),
        limite_creditos: obtenerLabelEtiqueta(
          "lbl_home_limite_creditos",
          listadoEtiquetas
        ),
        msj_buscar_asignatura: obtenerLabelEtiqueta(
          "lbl_global_msj_buscar_asignatura",
          listadoEtiquetas
        ),
        msj_resumen: obtenerLabelEtiqueta(
          "lbl_horario_msj_resumen",
          listadoEtiquetas
        ),

        reglamento_volver: obtenerLabelEtiqueta(
          "lbl_reglamento_volver",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
        global_cod: obtenerLabelEtiqueta("lbl_global_cod", listadoEtiquetas),
        global_asignatura: obtenerLabelEtiqueta(
          "lbl_global_asignatura",
          listadoEtiquetas
        ),
        horario_tipo_asignatura: obtenerLabelEtiqueta(
          "lbl_horario_tipo_asignatura",
          listadoEtiquetas
        ),
        horario_creditos: obtenerLabelEtiqueta(
          "lbl_horario_creditos",
          listadoEtiquetas
        ),
        horario_horas: obtenerLabelEtiqueta(
          "lbl_horario_horas",
          listadoEtiquetas
        ),
        horario_asignatura: obtenerLabelEtiqueta(
          "lbl_horario_asignatura",
          listadoEtiquetas
        ),
        horario_obli: obtenerLabelEtiqueta(
          "lbl_horario_obli",
          listadoEtiquetas
        ),
        global_elec: obtenerLabelEtiqueta("lbl_global_elec", listadoEtiquetas),
        global_com: obtenerLabelEtiqueta("lbl_global_com", listadoEtiquetas),
        horario_total_asignaturas: obtenerLabelEtiqueta(
          "lbl_horario_total_asignaturas",
          listadoEtiquetas
        ),
        horario_obligatorio: obtenerLabelEtiqueta(
          "lbl_horario_obligatorio",
          listadoEtiquetas
        ),
        horario_total_efectivo: obtenerLabelEtiqueta(
          "lbl_horario_total_efectivo",
          listadoEtiquetas
        ),
        horario_total_complementario: obtenerLabelEtiqueta(
          "lbl_horario_total_complementario",
          listadoEtiquetas
        ),
        horario_total_cred: obtenerLabelEtiqueta(
          "lbl_horario_total_cred",
          listadoEtiquetas
        ),
        horario_total_horas: obtenerLabelEtiqueta(
          "lbl_horario_total_horas",
          listadoEtiquetas
        ),
        lbl_horario_limite_creditos: obtenerLabelEtiqueta(
          "lbl_horario_limite_creditos",
          listadoEtiquetas
        ),
        lbl_horario_msj_llegas_creditos: obtenerLabelEtiqueta(
          "lbl_horario_msj_ llegas_creditos",
          listadoEtiquetas
        ),
        lbl_horario_min_creditos: obtenerLabelEtiqueta(
          "lbl_horario_min_creditos",
          listadoEtiquetas
        ),
        lbl_horario_msj_excediendo_creditos: obtenerLabelEtiqueta(
          "lbl_horario_msj_excediendo_creditos",
          listadoEtiquetas
        ),
        lbl_horario_max_credito: obtenerLabelEtiqueta(
          "lbl_horario_max_credito",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  const {
    global_seleccion_horario,
    asignaturas_habilitadas,
    horario_preliminar,
    limite_asignaturas,
    limite_creditos,
    msj_resumen,
    msj_buscar_asignatura,
    reglamento_volver,
    datos_continuar,
    global_cod,
    global_asignatura,
    horario_tipo_asignatura,
    horario_creditos,
    horario_horas,
    horario_asignatura,
    horario_obli,
    global_elec,
    global_com,
    horario_total_asignaturas,
    horario_obligatorio,
    horario_total_efectivo,
    horario_total_complementario,
    horario_total_cred,
    horario_total_horas,
    lbl_horario_limite_creditos,
    lbl_horario_msj_llegas_creditos,
    lbl_horario_min_creditos,
    lbl_horario_max_credito,
    lbl_horario_msj_excediendo_creditos,
  } = etiquetas;

  useEffect(() => {
    let countC2 = 0;
    let countE2 = 0;
    let countO2 = 0;
    let creditosCount2 = 0;
    let horasCount2 = 0;

    if (listAsignaturasAgregadas) {
      listAsignaturasAgregadas.map((data) => {
        if (data?.gtipo === "C") {
          countC2++;
        }
        if (data?.gtipo === "E") {
          countE2++;
        }
        if (data?.gtipo === "O") {
          countO2++;
        }
        let creditos = data?.ncreditos;
        creditosCount2 = creditosCount2 + creditos;
        let horas = data?.nhoras;
        horasCount2 = horasCount2 + horas;
      });

      setCountC(countC2);
      setCountE(countE2);
      setCountO(countO2);
      setCreditosCount(creditosCount2);
      setHorasCount(horasCount2);
    }
  }, [listAsignaturasAgregadas]);

  let retornameListaMultiSelect = () => {
    let listSelect = listadoAsignaturas.map((data) => {
      return { label: data.dcurso, value: data.dcurso };
    });

    return [...listSelect, { label: "", value: "", disabled: true }];
  };

  const getData = async () => {
    let asignaturas = await getAsignaturas()
    let grupos = await getGruposHabilitados()
    let lista_asignaturas = await listado_asignaturas_estudiante(obtenerDatosEstudiante,
      setListadoAsignaturasEstudiante, setLoading)
    if (asignaturas && grupos && lista_asignaturas) {
      setDisableBotonContinuar(false)
      setDisableBSelectFranjas(false)
    }
  }

  useEffect(() => {
    if (multifranjas) {
      if (franjaActual != '') {
        //Si la franja actual cambia, llama a las asignaturas y sesiones
        getData()
        setMostrarAsignaturas(true)
      } else {
        setDisableBSelectFranjas(false)
        setMostrarAsignaturas(false)
      }
    } else {
      getData()
      setMostrarAsignaturas(true)
    }
  }, [franjaActual]);


  useEffect(() => {
    const armarArrayDeGrupos = () => {
      let allAsignaguraXgrupos = listadoAsignaturas.map((la) => {
        let equivalentes = [];
        let itemsEquivalentes = [];

        gruposHabilitados.forEach((g) => {
          if (g.scurso == la.scurso) {
            //Se agrupa los cursos con todas sus asignaturas

            itemsEquivalentes = [...itemsEquivalentes, g];
          }
        });

        gruposHabilitados.forEach((g) => {
          if (g.scurso == la.scurso) {
            if (
              equivalentes.some((som) => som.sequivalente == g.sequivalente) ==
              false
            ) {
              let itemEqui = [];
              itemsEquivalentes.forEach((f) => {
                console.log(f, 'f');
                if (f.sequivalente == g.sequivalente && f.scurso == g.scurso) {
                  itemEqui = [...itemEqui, { f }];
                }
              });

              console.log(itemsEquivalentes, 'itemsEquivalentes');

              equivalentes = [
                ...equivalentes,
                {
                  sequivalente: g.sequivalente,
                  dequivalente: g.dequivalente,
                  dcurso: la.dcurso,
                  scurso: la.scurso,
                  ItemsEqui: itemEqui,
                },
              ];
            }
          }
        });

        let armarCadena = {
          binscrito: la.binscrito,
          nombreAsignatura: la.scurso + " - " + la.dcurso,
          sumilla: la.dsumilla,
          stipo: la.stipo,
          dtipo: la.dtipo,
          equivalentes,
        };

        return armarCadena;
        //  return
      });
      return allAsignaguraXgrupos;
    };
    if (gruposHabilitados.length > 0 && listadoAsignaturas.length > 0) {
      setGruposEquivalenteArmados(armarArrayDeGrupos());
      setGruposEquivalenteArmadosPadre(armarArrayDeGrupos());

      console.log(armarArrayDeGrupos(), 'armarArrayDeGrupos');
    }
  }, [gruposHabilitados, listadoAsignaturas]);


  useEffect(() => {
    if (Object.keys(obtenerDatosEstudiante).length > 0) {
      validarPeriodo(obtenerDatosEstudiante?.dperiodo);
      if (mincredito) {
        const listSesiones = async () => {
          try {
            setLoading(true);
            let data = await sesionesHabilitadas(obtenerDatosEstudiante);
            console.log(data, 'sesiones habilitadas');
            pushEventos(data);
          } catch (error) {
          } finally {
            setLoading(false);
          }
        };

        listSesiones();
      }
    }
  }, [obtenerDatosEstudiante]);

  const validarPeriodo = (periodo) => {
    if (periodo.length > 0) {
      let ultimo = periodo.slice(-1);
      if (ultimo == "C" || ultimo == "D" || ultimo == "D") {
        setMostrarBotonVolver(false)
      } else {
        setMostrarBotonVolver(true)
      }
    }
  }

  useEffect(() => {
    if (multifranjas) {
      setFranjaActual(franja)
      let franjaSeleccionadaFilter = listadoFranjas.filter(e => e.bfranja == true)
      setFranjaSeleccionadaHorario(franjaSeleccionadaFilter[0]?.sfranja ?? '')

      setListadoAsignaturas([])
    }
  }, [])


  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <button
        id="bntCruce"
        data-bs-toggle="modal"
        data-bs-target="#cruce"
        style={{ display: "none" }}
      ></button>
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body">
              <div className="matricula-title">
                <h5 className="text-uppercase">{global_seleccion_horario}</h5>
                <div className="separator"></div>
              </div>
              <div className="row mb-4">
                <div className="col-sm-12 col-md-5 col-lg-4">
                  <p className="text-uppercase fw-bolder">
                    {asignaturas_habilitadas}

                  </p>
                  {
                    multifranjas && <div className="d-flex flex-column gap-3">
                      <div className="form-group w-100">
                        <label className="fw-medium mb-2">Seleccionar franja:</label>
                        <select
                          className="form-select form-select-sm"
                          aria-label="Default select example"
                          onChange={(e) => {
                            handleSeleccionarFranja(e);
                          }}
                          value={franjaSeleccionadaHorario}
                          disabled={disableSelectFranjas}
                        >
                          <option value="" selected disabled={franja != '' && franja != null}>Seleccione una opción</option>

                          {listadoFranjas?.map((item) => {
                            return (
                              <option key={item?.sfranja} value={item?.sfranja}>
                                {item?.dfranja}
                              </option>
                            );
                          })}
                        </select>

                        <div className="input-group flex-nowrap mt-3">
                          <input
                            autoComplete="off"
                            type="text"
                            className="search-input form-control form-control-sm"
                            id="exampleFormControlInput1"
                            placeholder={msj_buscar_asignatura}
                            onChange={(e) => {
                              setBusquedaAsignatura(e.target.value);
                              handleBuscar(e.target.value, 2);
                            }}
                          />
                          <span
                            className="input-group-text login-control bg-white"
                            id="addon-wrapping"
                            style={{ cursor: "pointer" }}
                            onClick={handleBuscar}
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.59 12.41 8.11 13 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z"
                                fill="#B80A28"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  }

                  <div className=" d-block  d-md-none d-lg-none mt-3">
                    <MultiSelect
                      options={retornameListaMultiSelect()}
                      value={selected}
                      onChange={handleMultiSelect}
                      labelledBy={"Seleccione"}
                      isCreatable={true}
                      disableSearch={true}
                      hasSelectAll={false}
                    />
                  </div>

                  <div className="d-flex mt-4 justify-content-between">
                    {/* <p>
                      {limite_asignaturas}:
                      <span className="fw-bold">
                        {limitAsignatura.nlimitecursos}
                      </span>{" "}
                    </p> */}
                    <p>
                      {limite_creditos}:{" "}
                      <span className="fw-bold">
                        {limitAsignatura.nlimitecreditos}
                      </span>
                    </p>
                  </div>

                  {
                    mostrarAsignaturas ?

                      <div
                        className="accordion accordion-schedule"
                        id="accordionExampleCourses"
                      >
                        {listGruposEquivalenteArmados.map((data, index) => {
                          return (
                            <CardHorario
                              key={index}
                              index={index}
                              data={data}
                              limitCredito={limitAsignatura.nlimitecreditos}
                            />
                          );
                        })}
                      </div>
                      :
                      <div className="">
                        <div className="alert alert-warning" role="alert">
                          <p className="mb-0" style={{ lineHeight: "1.2" }}>
                            <svg
                              style={{ width: 24, height: 24, marginRight: 5 }}
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                              />

                            </svg>
                            Seleccione una franja para ver la oferta.
                          </p>
                        </div>
                      </div>
                  }

                </div>
                <div className="col-sm-12 col-md-7 col-lg-8">
                  <p className="text-uppercase fw-bolder">
                    {horario_preliminar}
                  </p>
                  <HorarioPanel />
                  <div className="cal-wrapper">
                    <div id="calendar" ></div>
                  </div>
                </div>

                <div className="col-12">
                  <div>
                    <p className="text-uppercase fw-bolder mt-4">
                      {msj_resumen}
                    </p>
                    <div className="d-block  d-md-none d-lg-none resumen-responsive">
                      {listAsignaturasAgregadas?.length > 0 &&
                        listAsignaturasAgregadas.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className={`border rounded-3 ${index != 0 && "mt-3"
                                }`}
                            >
                              <div className="d-flex p-2 bg-secondary-lighter">
                                <p className="fw-bold me-4 mb-0">
                                  {data?.scurso}
                                </p>
                                <p className="mb-0">{data?.dcurso}</p>
                              </div>
                              <div className="d-flex border-top justify-content-between p-2">
                                <p className="fw-medium me-2 mb-0">
                                  Tipo
                                  <br />{" "}
                                  <span>
                                    {
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={
                                          <Tooltip id={data?.gtipo}>
                                            {data?.ctipo}
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          className={`
                              ms-3 fs-sm 
                              ${data?.gtipo === "C"
                                              ? "icon-com"
                                              : data?.gtipo === "E"
                                                ? "icon-ele"
                                                : data?.gtipo === "O"
                                                  ? "icon-obli"
                                                  : ""
                                            }`}
                                        >
                                          <span variant="secondary">
                                            {data?.gtipo}
                                          </span>{" "}
                                        </button>
                                      </OverlayTrigger>
                                    }
                                  </span>
                                </p>
                                <p className="fw-medium me-2 mb-0">
                                  {horario_creditos} <br />{" "}
                                  <span className="fw-regular">
                                    {data?.ncreditos}
                                  </span>
                                </p>
                                <p className="fw-medium me-2 mb-0">
                                  {horario_horas}
                                  <br />{" "}
                                  <span className="fw-regular">
                                    {data?.nhoras}
                                  </span>
                                </p>
                              </div>
                            </div>
                          );
                        })}

                      <div className="total-resumen border rounded-3  mt-3">
                        <div className="d-flex justify-content-between border-bottom px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_total_asignaturas}
                          </p>
                          <p className="fw-medium me-1 mb-0">
                            {listAsignaturasAgregadas.length}{" "}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between border-bottom px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_obligatorio}
                          </p>
                          <p className="fw-medium me-1 mb-0 color-obli">
                            {countO}{" "}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between border-bottom px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_total_efectivo}
                          </p>
                          <p className="fw-medium me-1 mb-0 color-ele">
                            {countE}{" "}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between border-bottom px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_total_complementario}
                          </p>
                          <p className="fw-medium me-1 mb-0 color-com">
                            {countC}{" "}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between border-bottom px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_total_cred}.
                          </p>
                          <p className="fw-medium me-1 mb-0">
                            {creditosCount}{" "}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between px-2 py-1">
                          <p className="fw-bold w-50 me-1 mb-0">
                            {horario_total_horas}.
                          </p>
                          <p className="fw-medium me-1 mb-0">{horasCount} </p>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive table-schedule d-none d-md-block d-lg-block">
                      <table className="table table-striped">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">{global_asignatura}</th>
                            <th scope="col">Equivalente</th>
                            <th scope="col">Grupo</th>
                            <th scope="col" style={{ textAlign: "center" }}>
                              Tipo
                            </th>
                            <th scope="col">Modalidad</th>
                            <th scope="col">{horario_creditos}</th>
                            <th scope="col">{horario_horas}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listAsignaturasAgregadas &&
                            listAsignaturasAgregadas.map((data, index) => {
                              return <RowCourse data={data} key={index} />;
                            })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th scope="row" colSpan="3">
                              {listAsignaturasAgregadas.length}{" "}
                              {horario_asignatura}{" "}
                            </th>

                            <td colSpan="2" style={{ textAlign: "right" }}>
                              <span className="color-obli">{countO}</span>{" "}
                              {horario_obli}.{" "}
                              <span className="color-ele">{countE}</span>{" "}
                              {global_elec}.{" "}
                              <span className="color-com">{countC}</span>{" "}
                              {global_com}.
                            </td>
                            <td>{creditosCount}</td>
                            <td>{horasCount}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <button
              type="button"
              className={`btn waves-effect waves-light btn-light-secondary previous ${!mostrarBotonVolver && 'invisible'}`}
              onClick={atrasBtnHorario}
            >
              {reglamento_volver}
            </button>

            <button
              type="button"
              className="btn waves-effect waves-light btn-primary next"
              onClick={validarBtnHorario}
              disabled={disableBotonContinuar}
            >
              {datos_continuar}
            </button>
          </fieldset>
        </div>
      </div>

      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#confirmacion-horario-franja"
        id="modalConfirmarFranja"
      ></button>

      <ModalConfirmacionFranjaHorario guardarSeleccion={asignacionMasiva} franja={franjaSeleccionadaHorario} />

    </div>
  );
};

export default Horario;
